export const PERMISSIONS = {
  HUB: {
    MANAGE_USERS: 'hub:manage:users',
    MANAGE_ORGANIZATIONS: 'hub:manage:organizations',
  },
  RETRO: {
    DEBUG: 'retro:debug',
    APP: {
      ADMIN: 'retro:admin-access:app',
      READ: 'retro:read:app',
      WRITE: 'retro:write:app',
      DELETE: 'retro:delete:app',
      ANALOGS: 'retro:access:analogs',
    },
    API: {
      ADMIN: 'retro:admin-access:api',
      READ: 'retro:read:api',
      WRITE: 'retro:write:api-full',
      DELETE: 'retro:delete:api',
    },
  },
  MARIA: {
    DEBUG: 'maria:debug',
    READ: 'maria:read',
    WRITE: 'maria:write',
  },
  COUPLING: {
    READ: 'coupling:read',
    WRITE: 'coupling:write',
    DELETE: 'coupling:delete',
  },
} as const;

type ObjectLeaves<T> = T extends string
  ? T
  : {
      [K in keyof T]: ObjectLeaves<T[K]>;
    }[keyof T];

export type PermissionType = ObjectLeaves<typeof PERMISSIONS>;
